export class Delegation {
    constructor(
      id,
      name,
      erpRRHHId,
      deletedAt,
    ) {
        this.id = id;
        this.name = name;
        this.erpRRHHId = erpRRHHId;
        this.deletedAt = deletedAt;
    }
    static createFromResponseData(data) {
      if (!data) {
        return null;
      }
      return new Delegation(
        data.id,
        data.name,
        data.erpRRHHId,
        data.deletedAt,
      );
    }
  };